import './App.css';
import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

const numPerPage = 120

function App() {
  const [html, setHtml] = useState('')
  const [list, setList] = useState([])
  const [page, setPage] = useState(useSearchParams()[0].get('page')||1)
  const [totalPage, setTotalPage] = useState(1)
  const { id } = useParams();

  useEffect(_ => {
    fetch(`./json/${id}.json`)
      .then(response => response.json())
      .then(json => {
        const { html, list } = json
        setHtml(decodeURIComponent(html.replaceAll('\n', '').replaceAll('<a', '\n<a').replaceAll(' page', '\n page').replace('//photo.yupoo.com', 'http://pic.yupoo.com')))

        setTotalPage(Math.ceil(list.length / numPerPage))
        setList(list.slice((page - 1) * numPerPage, page * numPerPage))
      });
  }, [])

  return (
    <div className='main'>
      <div dangerouslySetInnerHTML={{
        __html: html
      }}>
      </div>
      <div className="showalbum__imagecardwrap">
        <div className="showalbum__parent showalbum__nor nor">
          {list.filter(_ => !!_).map((_, index) => {
            const b = _.slice(-12)
            const small = _.replace(b, 'small.jpg')
            return <div className="showalbum__children image__main" key={_}>
              <div className="image__imagewrap" data-type="photo">
                <img className="autocover image__img image__portrait" src={`http://pic.yupoo.com/` + small} />
                <div className="image__clickhandle"></div>
              </div>
              <div className="image__decwrap">
                <h3 title="1" className="text_overflow">{index + 1}</h3>
                <p className="text_overflow"></p>
                <time className="text_overflow">
                </time>
              </div>
            </div>
          })}
        </div>
      </div>
      <nav className="pagination__main">
        <div className="none_select pagination__buttons"><a className="pagination__button" href={window.location.origin + window.location.pathname + "?page=" + (Number(page) > 2 ? (Number(page) - 1) : 1)} title="previous page"><i className="icon_prev font_icon_12"></i></a>
          {Array(totalPage).fill(1).map((p, index) => <a href={window.location.origin + window.location.pathname + "?page=" + String(index + 1)} key={index} className={(index + 1) == page ? 'pagination__active pagination__number pagination__button' : 'pagination__number pagination__button'}>{index + 1}</a>)}
          <a className="pagination__button " href={window.location.origin + window.location.pathname + "?page=" + ((Number(page) == totalPage ? page : (Number(page) + 1)))} title="next page"><i className="icon_next font_icon_12"></i></a>
        </div>
        <form className="pagination__jumpwrap">
          <span>in total {totalPage} pages</span>
          <span>to         <input name="page" type="number" step="1" min="1" max="3" />
            page</span>
          <span><button type="submit" className="pagination__button">confirm</button></span>
        </form>
      </nav>
    </div>
  );
}

export default App;
